import { Link } from "react-router-dom";
import { NotificationItemProps } from "../../types/components/NotificationItemProps";

const NotificationItem = ({ path, icon, subtitle, title, onRemoveClick }: NotificationItemProps) => {
  return (
    <div className="item-notification cadre-bloc">
      <Link to={path}>
        <div className="img-notification">{icon}</div>
        <div className="detail-item-notification">
          <p className="title-item-notification">{title}</p>
          <span>{subtitle}</span>
        </div>
      </Link>
      <button className="btn-close-notif" onClick={onRemoveClick}>
        <i className="icon-close" />
      </button>
    </div>
  );
};

export default NotificationItem;
